module.exports = __webpack_public_path__ + "img/DJI_0048.0bc210a0.jpg";